import { useContext } from 'react';

import { EnvironmentContext } from './environment.context';

export function useIsInProduction() {
  const env = useContext(EnvironmentContext);
  return env === 'Production';
}

export function useIsNotInProduction() {
  const inProd = useIsInProduction();
  return !inProd;
}
